module.exports = __webpack_public_path__ + "static/1-large-7fbedc0da47234b90a7ae417c961e1da.jpg";